export default __webpack_public_path__ + "static/media/charisma_name.5648bf83.png";